import { Block, Title, Ico } from "./styled";

const LoadingPage = () => {
    return (
        <Block>
            <Title>Please wait, projects are being loaded...</Title>
            <Ico />
        </Block>
    )
};

export default LoadingPage;